import { buildPagination } from "../modules/pagination"
import { buildTilePlaceholders, buildTiles } from "../modules/tile"
import { isMobile } from "../modules/utils"

declare var $

export class DevelopmentList {

	el: HTMLElement
  apiRoot: string
  resultsEl?: Element
  page: number
  pageCount: number
  perPage: number
  category: string

  constructor(el) {
		this.el = el
    this.resultsEl = $('.development-list__results', this.el).get(0)
    this.page = 1
    this.pageCount = 1
    this.perPage = 4
    this.category = ''
    this.apiRoot = ''
    this.init()
  }

  init() {
    // Get REST url
    const $link = $( 'link[rel="https://api.w.org/"]' )
    this.apiRoot = $link.attr( 'href' )

    this.clearResults()
    if ( $('.category-tab button', this.el).length > 1 ) {
      this.filter( $('.category-tab button', this.el).eq(1).get(0) )
    } else {
      this.filter( $('.category-tab button', this.el).eq(0).get(0) )
    }
    this.enable()
  }

  enable() {
    $(this.el)
      .on('click', 'a[href="#nextPage"]', (e)=>{
        e.preventDefault()
        let newPage = this.page + 1
        if (newPage <= this.pageCount) {
          this.page = newPage
          this.fetchDevelopments(true)
        }
      })
      .on('click', 'a[href="#prevPage"]', (e)=>{
        e.preventDefault()
        let newPage = this.page - 1
        if (newPage >= 1) {
          this.page = newPage
          this.fetchDevelopments(true)
        }
      })
      .on('click', 'a[href="#toPage"]', (e)=>{
        e.preventDefault()
        let newPage = parseInt($(e.currentTarget).data('page'))
        if (newPage >= 1 && newPage <= this.pageCount) {
          this.page = newPage
          this.fetchDevelopments(true)
        }
      })
      .on('click', '.category-tab button', (e)=>{
        e.preventDefault()
        this.filter( e.currentTarget )
        this.closeFilter()
      })
      .on('click', '.category-tab-toggle', (e)=>{
        e.preventDefault()
        this.toggleFilter()
      })
  }

  fetchDevelopments(scrollToTop:boolean = false) {

    this.clearResults()

    const params = {
      category: this.category,
      page: this.page,
      per_page: this.perPage
    }

    $.ajax({
      url: this.apiRoot + 'keystone/v1/developments',
      method: 'GET',
      data: params
    }).done(data => {
      this.buildResults( data.results )
      this.updatePagination( data.count )
      if (scrollToTop) this.scrollToTop()
    })
  }

  /**
   * Filter
   */

  filter( newCategoryBtn:HTMLButtonElement ) {
    const newCategory = $(newCategoryBtn).val()
    const newCategoryLabel = $(newCategoryBtn).text()
    if (this.category == newCategory && this.category == 'all') return
    if (this.category !== '') {
      $('.category-tab-toggle', this.el).text(newCategoryLabel)
    }
    if (this.category == newCategory && this.category !== 'all') {
      this.category = 'all'
    } else {
      this.category = newCategory  
    }
    $('.category-tab button', this.el).removeClass('active')
    $('.category-tab button[value="'+this.category+'"]', this.el).addClass('active')
    
    this.page = 1
    this.fetchDevelopments()
  }


  /**
   * List display
   */

  buildResults( results ) {
    if ($(this.resultsEl).hasClass('placeholder')) {
      $(this.resultsEl).removeClass('placeholder').html('')
    }
    if (results.length === 0) {
      $(this.resultsEl).html('<p class="no-results"><span class="body-xl">No programs found</span>')
    } else {
      $(this.resultsEl).html('').append( buildTiles(results, 'development-tile') )
    }
  }

  clearResults() {
    $(this.resultsEl)
      .addClass('placeholder')
      .html( buildTilePlaceholders(this.perPage, 'development-tile') )
  }

  scrollToTop() {
    const top = $(this.el).offset().top - (isMobile()?0:80)
    $('html, body').animate({ scrollTop: top }, 1200, 'swing')
  }

  /**
   * Pagination
   */

  updatePagination( count ) {
    const $paginationContainer = $('.development-list__pagination', this.el)
    this.pageCount = Math.ceil(count / this.perPage)
    if (this.pageCount <= 1) {
      $paginationContainer.html('')
    } else {
      $paginationContainer.html( buildPagination( this.pageCount, this.page ) )
    }
  }

  /**
   * Filter Toggle
   */

  openFilter() {
    $('.category-tab-list', this.el).addClass('open')
  }
  closeFilter() {
    $('.category-tab-list', this.el).removeClass('open')
  }
  toggleFilter() {
    $('.category-tab-list', this.el).toggleClass('open')
  }

}